import Entity from '../entity'
export default class Cliente extends Entity<number>{
    nombre: string;
    pais: string;
    imagen: string;
    fileContent: string;
}